module.exports = __webpack_public_path__ + "static/img/p1.e7f885d0.png";